import React from 'react'
import { Col } from 'antd'
import { useTranslation } from 'lib/i18n'

import Box from 'components/Box/Box'
import CtaLink from 'components/CtaLink/CtaLink'
import Heading from 'components/Heading/Heading'
import Link from 'components/Link/Link'
import Markdown from 'components/Markdown/Markdown'

import styles from './BlogPost.module.css'

interface BlogPostProps {
  id: number | string
  slug: string
  title: string
  image: string
  excerpt: string
  categorySlug?: string
}

const BlogPost = ({
  id,
  slug,
  title,
  image,
  excerpt,
  categorySlug = '',
}: BlogPostProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Col xs={24} md={8} className={styles.blogPostWrapper}>
      <article className={styles.blogPost}>
        <Link href={`/blog/${categorySlug}/${slug}`}>
          <a>
            <Box key={`blogPost_${id}`} header={<img src={image} alt="" />}>
              <Heading>
                <h2>{title}</h2>
              </Heading>
              <div className={styles.excerpt}>
                <Markdown>{excerpt}</Markdown>
              </div>
              <CtaLink stylesOnly>
                {t('BlogPost.readMore2', 'Read more')}
              </CtaLink>
            </Box>
          </a>
        </Link>
      </article>
    </Col>
  )
}

export default BlogPost
